import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/HomeView.vue"),
      meta: {
        requireAuth: !0,
        title: "Homepage - ITAD Association",
        description:
          "This is your space with all the tools and resources you need to work efficiently in the IT equipment trading industry.",
        twitterTitle: "Homepage - ITAD Association",
        canonical: "/",
        ogTitle: "Homepage - ITAD Association",
        ogUrl: "/",
      },
    },
    {
      path: "/members/directory",
      name: "directory",
      component: () => import("@/DirectoryView.vue"),
      meta: {
        requireAuth: !0,
        title: "Directory - ITAD Association",
        description:
          "ASCDI Members can access an ENHANCED searchable database of members and non-members which includes company information, contact information, products sold and a whole lot more.",
        twitterTitle: "Directory - ITAD Association",
        canonical: "/members/directory",
        ogTitle: "Directory - ITAD Association",
        ogUrl: "/members/directory",
      },
    },
    {
      path: "/members/trading-network",
      name: "trading-network",
      component: () => import("@/TradingNetworkView.vue"),
      meta: {
        requireAuth: !0,
        title: "Trading Network - ITAD Association",
        description:
          "Subscribers to the ASCDI Trading Network (eTN Subscribers) will have access to features and tools to help you in the buying and selling of equipment.",
        twitterTitle: "Trading Network - ITAD Association",
        canonical: "/members/trading-network",
        ogTitle: "Trading Network - ITAD Association",
        ogUrl: "/members/trading-network",
      },
    },
    {
      path: "/members/search",
      name: "search",
      component: () => import("@/SearchView.vue"),
      meta: {
        requireAuth: !0,
        title: "PowerSearch - ITAD Association",
        description:
          "Search for equipment in our database using keywords. You can also filter by how recent the listings are and save your search for future use.",
        twitterTitle: "PowerSearch - ITAD Association",
        canonical: "/members/search",
        ogTitle: "PowerSearch - ITAD Association",
        ogUrl: "/members/search",
      },
    },
    {
      path: "/members/search/:id",
      name: "search-details",
      component: () => import("@/SearchDetailsView.vue"),
      meta: {
        requireAuth: !0,
        title: "PowerSearch - ITAD Association",
        description:
          "Search for equipment in our database using keywords. You can also filter by how recent the listings are and save your search for future use.",
        twitterTitle: "PowerSearch - ITAD Association",
        canonical: "/members/search",
        ogTitle: "PowerSearch - ITAD Association",
        ogUrl: "/members/search",
      },
    },
    {
      path: "/members/searches",
      name: "searches",
      component: () => import("@/SearchesView.vue"),
      meta: {
        requireAuth: !0,
        title: "Own Searches - ITAD Association",
        description:
          "Use this page to delete or edit your currently saved searches. If you edit you can choose to have us e-mail you this search daily at a time of your choosing.",
        twitterTitle: "Own Searches - ITAD Association",
        canonical: "/members/searches",
        ogTitle: "Own Searches - ITAD Association",
        ogUrl: "/members/searches",
      },
    },
    {
      path: "/members/add-listing",
      name: "add-listing",
      component: () => import("@/BroadcastAddView.vue"),
      meta: {
        requireAuth: !0,
        title: "Broadcast-Add (PowerMail) - ITAD Association",
        description:
          "Use this page to enter equipment into our database for others to find when they PowerSearch AND to email this info to all dealers who have signed up to receive that manufacturer's listings.",
        twitterTitle: "Broadcast-Add (PowerMail) - ITAD Association",
        canonical: "/members/add-listing",
        ogTitle: "Broadcast-Add (PowerMail) - ITAD Association",
        ogUrl: "/members/add-listing",
      },
    },
    {
      path: "/members/upload",
      name: "upload",
      component: () => import("@/UploadView.vue"),
      meta: {
        requireAuth: !0,
        title: "PowerLoad - ITAD Association",
        description:
          "Use this page to enter equipment into our database for others to find when they PowerSearch AND to email this info to all dealers who have signed up to receive that manufacturer's listings.",
        twitterTitle: "PowerLoad - ITAD Association",
        canonical: "/members/upload",
        ogTitle: "PowerLoad - ITAD Association",
        ogUrl: "/members/upload",
      },
    },
    {
      path: "/members/broadcast-email",
      name: "broadcast-email",
      component: () => import("@/BroadcastEmailView.vue"),
      meta: {
        requireAuth: !0,
        title: "PowerCast - ITAD Association",
        description:
          "Use this page to enter equipment into our database for others to find when they PowerSearch AND to email this info to all dealers who have signed up to receive that manufacturer's listings. The optional Date Available/Needed field is meant to inform your fellow traders when the equipment you are selling will be available, or when you need it. The Researching Box is to let them know if you are not yet a buyer/seller but are just researching the market.",
        twitterTitle: "PowerCast - ITAD Association",
        canonical: "/members/broadcast-email",
        ogTitle: "PowerCast - ITAD Association",
        ogUrl: "/members/broadcast-email",
      },
    },
    {
      path: "/members/mail-details/:id",
      name: "mail-details",
      component: () => import("@/MailDetailsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Mail Details - ITAD Association",
        description: "Mail Details",
        twitterTitle: "Mail Details - ITAD Association",
        canonical: "/members/mail-details",
        ogTitle: "Mail Details - ITAD Association",
        ogUrl: "/members/mail-details",
      },
    },
    {
      path: "/members/admin/ethics-records",
      name: "admin-ethics-records",
      component: () => import("@/AdminEthicsRecordsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Manage Ethics Records - ITAD Association",
        description: "Admin CRUD for ethics records.",
        canonical: "/members/admin/ethics-records",
      },
    },
    {
      path: "/members/admin/library",
      name: "admin-library",
      component: () => import("@/AdminLibraryView.vue"),
      meta: {
        requireAuth: !0,
        title: "Manage Document Library - ITAD Association",
        description: "Admin upload/delete for the member document library.",
        canonical: "/members/admin/library",
      },
    },
    {
      path: "/members/member-directory",
      name: "member-directory",
      component: () => import("@/MemberDirectoryView.vue"),
      meta: {
        requireAuth: !0,
        title: "Dealer Search and Email - ITAD Association",
        description:
          "Search for ITAD Association and/or eTN members with the option to e-mail them.",
        twitterTitle: "Dealer Search and Email - ITAD Association",
        canonical: "/members/member-directory",
        ogTitle: "Dealer Search and Email - ITAD Association",
        ogUrl: "/members/member-directory",
      },
    },
    {
      path: "/members/member-details/:id",
      name: "member-details",
      component: () => import("@/MemberDetailsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Member Details - ITAD Association",
        description: "Member Details",
        twitterTitle: "Member Details - ITAD Association",
        canonical: "/members/member-details",
        ogTitle: "Member Details - ITAD Association",
        ogUrl: "/members/member-details",
      },
    },
    {
      path: "/members/contact-details/:id",
      name: "contact-details",
      component: () => import("@/ContactDetailsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Contact Details - ITAD Association",
        description: "Contact Details",
        twitterTitle: "Contact Details - ITAD Association",
        canonical: "/members/contact-details",
        ogTitle: "Contact Details - ITAD Association",
        ogUrl: "/members/contact-details",
      },
    },
    {
      path: "/members/contact-manufacturers/:id",
      name: "contact-manufacturers",
      component: () => import("@/ContactManufacturersView.vue"),
      meta: {
        requireAuth: !0,
        title: "Contact Manufacturers - ITAD Association",
        description: "Contact Manufacturers",
        twitterTitle: "Contact Manufacturers - ITAD Association",
        canonical: "/members/contact-manufacturers",
        ogTitle: "Contact Manufacturers - ITAD Association",
        ogUrl: "/members/contact-manufacturers",
      },
    },
    {
      path: "/members/ask-the-pros",
      name: "ask-the-pros",
      component: () => import("@/AskTheProsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Ask the Pros - ITAD Association",
        description:
          "This is a member-only service where you can get free advice from experts in various fields. If you need more help, they will be happy to offer their services directly.",
        twitterTitle: "Ask the Pros - ITAD Association",
        canonical: "/members/contact-ask-the-pros",
        ogTitle: "Ask the Pros - ITAD Association",
        ogUrl: "/members/contact-ask-the-pros",
      },
    },
    {
      path: "/members/settings",
      name: "settings",
      component: () => import("@/SettingsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Settings - ITAD Association",
        description: "Settings",
        twitterTitle: "Settings - ITAD Association",
        canonical: "/members/settings",
        ogTitle: "Settings - ITAD Association",
        ogUrl: "/members/settings",
      },
    },
    {
      path: "/members/edit-contact/:id",
      name: "edit-contact",
      component: () => import("@/EditContactSettingsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Edit Contact - ITAD Association",
        description: "Edit Contact",
        twitterTitle: "Edit Contact - ITAD Association",
        canonical: "/members/edit-contact",
        ogTitle: "Edit Contact - ITAD Association",
        ogUrl: "/members/edit-contact",
      },
    },
    {
      path: "/members/contacts/add",
      name: "add-contact",
      component: () => import("@/AddContactSettingsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Add Contact - ITAD Association",
        description: "Add Contact",
        twitterTitle: "Add Contact - ITAD Association",
        canonical: "/members/contacts/add",
        ogTitle: "Add Contact - ITAD Association",
        ogUrl: "/members/contacts/add",
      },
    },
    {
      path: "/members/cisco-members",
      name: "cisco-members",
      component: () => import("@/CiscoMembersView.vue"),
      meta: {
        requireAuth: !0,
        title: "Cisco Information Clearing House-for Members - ITAD Association",
        description:
          "We have set up this section of the ITAD Association Web site as a place for Members to share information about CISCO products and the CISCO Market.",
        twitterTitle:
          "Cisco Information Clearing House-for Members - ITAD Association",
        canonical: "/members/cisco-members",
        ogTitle: "Cisco Information Clearing House-for Members - ITAD Association",
        ogUrl: "/members/cisco-members",
      },
    },
    {
      path: "/members/imb-information",
      name: "imb-information",
      component: () => import("@/ImbInformationView.vue"),
      meta: {
        requireAuth: !0,
        title: "IBM Information for ASCDI Members only - ITAD Association",
        description:
          "One of the jobs of the ASCDI is to communicate with IBM and IBM Global Asset Recovery Services (IBM GARS) on behalf or our Members in order to keep our members informed about IBM's Practices and Polices. We thank IBM for working with us to include in Members Only section of this Web site the information below.",
        twitterTitle: "IBM Information for ASCDI Members only - ITAD Association",
        canonical: "/members/imb-information",
        ogTitle: "IBM Information for ASCDI Members only - ITAD Association",
        ogUrl: "/members/imb-information",
      },
    },
    {
      path: "/members/member-library",
      name: "member-library",
      component: () => import("@/MemberLibraryView.vue"),
      meta: {
        requireAuth: !0,
        title: "Member Document Library - ITAD Association",
        description: "Member Document Library",
        twitterTitle: "Member Document Library - ITAD Association",
        canonical: "/members/member-library",
        ogTitle: "Member Document Library - ITAD Association",
        ogUrl: "/members/member-library",
      },
    },
    {
      path: "/members/manage-listing",
      name: "manage",
      component: () => import("@/ManageListingView.vue"),
      meta: {
        requireAuth: !0,
        title: "Manage Listings - ITAD Association",
        description:
          "This page allows you to manage your listings. Use the buttons below to either delete or re-list all of you listings. You can also use this page to search for your OWN listings in order to see, update or remove your listings. Leave the box below empty and click on SEARCH to see all of your listings OR enter criteria into the box to narrow down your search.",
        twitterTitle: "Manage Listings - ITAD Association",
        canonical: "/members/manage-listing",
        ogTitle: "Manage Listings - ITAD Association",
        ogUrl: "/members/manage-listing",
      },
    },
    {
      path: "/members/equip-spec-sheets",
      name: "equip-spec-sheets",
      component: () => import("@/EquipSpecSheetsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Equipment Specifications Look up - ITAD Association",
        description:
          "Enter as much information as you can to search our database. For example if you enter (cisco 4 port) you will get a listing of all products with Cisco 4 port in their product description. Then click on view to see the details.",
        twitterTitle: "Equipment Specifications Look up - ITAD Association",
        canonical: "/members/equip-spec-sheets",
        ogTitle: "Equipment Specifications Look up - ITAD Association",
        ogUrl: "/members/equip-spec-sheets",
      },
    },
    {
      path: "/members/ethics-records",
      name: "ethics-records",
      component: () => import("@/EthicsRecordsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Ethics Records - ITAD Association",
        description:
          "Violators, non-participants, and fraud alerts under the ASCDI Code of Ethics.",
        twitterTitle: "Ethics Records - ITAD Association",
        canonical: "/members/ethics-records",
        ogTitle: "Ethics Records - ITAD Association",
        ogUrl: "/members/ethics-records",
      },
    },
    // Legacy paths — redirect into the combined view so old deep links keep working.
    {
      path: "/members/violations",
      redirect: "/members/ethics-records",
    },
    {
      path: "/members/ethics-non-participants",
      redirect: "/members/ethics-records",
    },
    {
      path: "/members/selective-broadcast-email",
      name: "selective-broadcast-email",
      component: () => import("@/SelectiveBroadcastEmailView.vue"),
      meta: {
        requireAuth: !0,
        title: "Selective Broadcast Email - ITAD Association",
        description: "Selective Broadcast Email.",
        twitterTitle: "Selective Broadcast Email - ITAD Association",
        canonical: "/members/selective-broadcast-email",
        ogTitle: "Selective Broadcast Email - ITAD Association",
        ogUrl: "/members/selective-broadcast-email",
      },
    },
    {
      path: "/members/listing-details/:id",
      name: "listing-details",
      component: () => import("@/ListingDetailsView.vue"),
      meta: {
        requireAuth: !0,
        title: "Listing Details - ITAD Association",
        description: "Listing Details.",
        twitterTitle: "Listing Details - ITAD Association",
        canonical: "/members/listing-details",
        ogTitle: "Listing Details - ITAD Association",
        ogUrl: "/members/listing-details",
      },
    },
    {
      path: "/members/listing-edit/:id",
      name: "listing-edit",
      component: () => import("@/ListingEditView.vue"),
      meta: {
        requireAuth: !0,
        title: "Edit Details - ITAD Association",
        description: "Edit Details.",
        twitterTitle: "Edit Details - ITAD Association",
        canonical: "/members/listing-edit",
        ogTitle: "Edit Details - ITAD Association",
        ogUrl: "/members/listing-edit",
      },
    },
    {
      path: "/members/login",
      name: "signin",
      component: () => import("@/SignInView.vue"),
      meta: {
        title: "Login - ITAD Association",
        description: "Login.",
        twitterTitle: "Login - ITAD Association",
        canonical: "/members/login",
        ogTitle: "Login - ITAD Association",
        ogUrl: "/members/login",
      },
    },
    {
      path: "/members/contact-set-password/:id",
      name: "contact-set-password",
      component: () => import("@/ContactSetPasswordView.vue"),
      meta: {
        requireAuth: !0,
        title: "Update Password - ITAD Association",
        description: "Update Password.",
        twitterTitle: "Update Password - ITAD Association",
        canonical: "/members/contact-set-password",
        ogTitle: "Update Password - ITAD Association",
        ogUrl: "/members/contact-set-password",
      },
    },
    {
      path: "/members/contacts/manage",
      name: "contacts-listing",
      component: () => import("@/ContactsListingView.vue"),
      meta: {
        requireAuth: !0,
        title: "Manage Contacts - ITAD Association",
        description: "Manage Contacts.",
        twitterTitle: "Manage Contacts - ITAD Association",
        canonical: "/members/contacts/manage",
        ogTitle: "Manage Contacts - ITAD Association",
        ogUrl: "/members/contacts/manage",
      },
    },
    {
      path: "/members/contact-edit/:id",
      name: "contact-edit",
      component: () => import("@/ContactEditView.vue"),
      meta: {
        requireAuth: !0,
        title: "Edit Contact - ITAD Association",
        description: "Edit Contact.",
        twitterTitle: "Edit Contact - ITAD Association",
        canonical: "/members/contact-edit",
        ogTitle: "Edit Contact - ITAD Association",
        ogUrl: "/members/contact-edit",
      },
    },
    {
      path: "/members/manage",
      name: "members-listing",
      component: () => import("@/MembersListingView.vue"),
      meta: {
        requireAuth: !0,
        title: "Manage Members - ITAD Association",
        description: "Manage Members.",
        twitterTitle: "Manage Members - ITAD Association",
        canonical: "/members/manage",
        ogTitle: "Manage Members - ITAD Association",
        ogUrl: "/members/manage",
      },
    },
    {
      path: "/members/member-edit/:id",
      name: "member-edit",
      component: () => import("@/MemberEditView.vue"),
      meta: {
        requireAuth: !0,
        title: "Edit Member - ITAD Association",
        description: "Edit Member.",
        twitterTitle: "Edit Member - ITAD Association",
        canonical: "/members/member-edit",
        ogTitle: "Edit Member - ITAD Association",
        ogUrl: "/members/member-edit",
      },
    },
    {
      path: "/members/add-member",
      name: "add-member",
      component: () => import("@/MemberAddView.vue"),
      meta: {
        requireAuth: !0,
        title: "Add Member - ITAD Association",
        description: "Add Member.",
        twitterTitle: "Add Member - ITAD Association",
        canonical: "/members/add-member",
        ogTitle: "Add Member - ITAD Association",
        ogUrl: "/members/add-member",
      },
    },
    {
      path: "/members/manufacturers/manage",
      name: "manufacturers",
      component: () => import("@/ManufacturersView.vue"),
      meta: {
        requireAuth: !0,
        title: "Manage Manufacturers - ITAD Association",
        description: "Manage Manufacturers.",
        twitterTitle: "Manage Manufacturers - ITAD Association",
        canonical: "/members/manufacturers/manage",
        ogTitle: "Manage Manufacturers - ITAD Association",
        ogUrl: "/members/manufacturers/manage",
      },
    },
    {
      path: "/members/manufacturers/edit/:id",
      name: "edit-manufacturer",
      component: () => import("@/EditManufacturerView.vue"),
      meta: {
        requireAuth: !0,
        title: "Edit Manufacturer - ITAD Association",
        description: "Edit Manufacturer.",
        twitterTitle: "Edit Manufacturer - ITAD Association",
        canonical: "/members/edit-manufacturer",
        ogTitle: "Edit Manufacturer - ITAD Association",
        ogUrl: "/members/edit-manufacturer",
      },
    },
    {
      path: "/members/manufacturers/add",
      name: "add-manufacturer",
      component: () => import("@/AddManufacturerView.vue"),
      meta: {
        requireAuth: !0,
        title: "Add Manufacturer - ITAD Association",
        description: "Add Manufacturer.",
        twitterTitle: "Add Manufacturer - ITAD Association",
        canonical: "/members/add-manufacturer",
        ogTitle: "Add Manufacturer - ITAD Association",
        ogUrl: "/members/add-manufacturer",
      },
    },
    {
      path: "/members/member-mailer",
      name: "member-mailer",
      component: () => import("@/MemberMailerView.vue"),
      meta: {
        requireAuth: !0,
        title: "Member Mailer - ITAD Association",
        description: "Member Mailer.",
        twitterTitle: "Member Mailer - ITAD Association",
        canonical: "/members/member-mailer",
        ogTitle: "Member Mailer - ITAD Association",
        ogUrl: "/members/member-mailer",
      },
    },
    {
      path: "/members/agreement",
      name: "agreement",
      component: () => import("@/AgreementView.vue"),
      meta: {
        title: "Subscriber Agreement - ITAD Association",
        description: "Subscriber Agreement.",
        twitterTitle: "Subscriber Agreement - ITAD Association",
        canonical: "/members/agreement",
        ogTitle: "Subscriber Agreement - ITAD Association",
        ogUrl: "/members/agreement",
      },
    },
    {
      path: "/:pathMatch(.*)*",
      name: "error-view",
      component: () => import("@/ErrorView.vue"),
      meta: {
        isError: true,
        title: "404 - ITAD Association",
        description: "404.",
        twitterTitle: "404 - ITAD Association",
        canonical: "/",
        ogTitle: "404 - ITAD Association",
        ogUrl: "/",
      },
    },
  ],
});

router.beforeEach(async (to, from) => {
  try {
    window.document.title = to.meta && to.meta.title ? to.meta.title : "";
    const metaDescription = document.createElement("meta");
    metaDescription.setAttribute("name", "description");
    metaDescription.setAttribute("content", to.meta.description);
    document.head.appendChild(metaDescription);
    document
      .querySelector('link[rel="canonical"]')
      .setAttribute("href", to.meta.canonical);
    document
      .querySelector('meta[property="og:title"]')
      .setAttribute("content", to.meta.ogTitle);
    document
      .querySelector('meta[property="og:url"]')
      .setAttribute("content", to.meta.ogUrl);
    document
      .querySelector('meta[name="twitter:title"]')
      .setAttribute("content", to.meta.twitterTitle);
    document
      .querySelector('meta[name="twitter:description"]')
      .setAttribute("content", to.meta.description);

    const user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : false;
    const { meta: { requireAuth = false } = {} } = to;
    if (user && to.name === "signin") {
      return "/";
    }
    if (requireAuth && !user) {
      return `/members/login`;
    }
  } catch (error) {
    return `/members/login`;
  }
});

export default router;
